import { Building2, ClipboardList, Compass, Database, Eye, FileText, Flag, IdCard, Target } from "lucide-react";
import { NODE_TYPES } from "../lib/constants";

const ICONS = { avdelning: Building2, uppgift: ClipboardList, syfte: Target, system: Database, roll: IdCard, dokument: FileText, vision: Eye, malbild: Flag, strategi: Compass };

export default function NodePalette({ onAdd }) {
    return (
        <div className="w-[150px] xl:w-[200px] shrink-0 border-r border-border bg-canvas/60 backdrop-blur p-2 xl:p-3 flex flex-col gap-2 overflow-y-auto" data-testid="node-palette">
            <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mb-1">Bygg kartan</p>
            {Object.entries(NODE_TYPES).filter(([type]) => !["roll", "uppgift"].includes(type)).map(([type, t]) => {
                const Icon = ICONS[type];
                return (
                    <button
                        key={type}
                        data-testid={`add-node-${type}`}
                        draggable
                        onDragStart={(e) => e.dataTransfer.setData("application/hamn-node", type)}
                        onClick={() => onAdd(type)}
                        className="flex items-center gap-2.5 rounded-lg border border-border bg-deepsea/70 px-3 py-2.5 text-left hover:border-current/50 hover:bg-deepsea transition-all cursor-grab active:cursor-grabbing group"
                    >
                        <span className="w-1.5 h-8 rounded-full" style={{ background: t.color }} />
                        <div className="flex-1">
                            <div className="text-[13px] font-semibold text-slate-200">{t.label}</div>
                            <div className="font-mono text-[9px] uppercase tracking-widest text-slate-500 group-hover:text-slate-400">dra eller klicka</div>
                        </div>
                        <Icon className="w-4 h-4 text-slate-500" />
                    </button>
                );
            })}
            <p className="hidden xl:block text-[11px] text-slate-500 leading-relaxed mt-2">
                Dra mellan nodernas kopplingspunkter för att skapa relationer. Klicka på en nod för detaljer, källor och dammar.
            </p>
            <p className="hidden xl:block text-[11px] text-slate-500 leading-relaxed">
                Roller och uppgifter läggs inne i avdelningsnoden – se även vyn Rollmatris.
            </p>
        </div>
    );
}
